export const CLIENT_KEY =
    'o07rEE8LYmsgGTBkvUOQfnlb9AfKB5Beqis9mODj9Fs7fdFN3H0bME1iJn9VShUJ4riAOXwbyf8q9IltnnrZi1dGr9oS2kV39WXD7Ty7beZwkm4ug23k0uNR5LXLljES'

export const STRIPE_KEY = 'pk_live_7DOiYyVStvnUGhB7AIbiCkDm'
// process.env.NODE_ENV == 'production'
//     ? 'pk_live_7DOiYyVStvnUGhB7AIbiCkDm'
//     : 'pk_test_ipN4imKuGdNbZqZW5iJPfJiM'

export const MOBILEWIDTH = 720
